import type { TicketList } from './ticket-list.types'

import { sessionCache } from '@/utils/session-cache'

/** Each list page's tickets by its URL, so the ticket page knows which list it was opened from.
 *  Logout clears it (auth.store.ts). */
const cache = sessionCache<TicketList>('adx_ticket_list:')

export const readTicketList = (path: string): TicketList | null => cache.read(path)

export const writeTicketList = (path: string, list: TicketList): void => cache.write(path, list)

export const clearTicketLists = (): void => cache.clear()
